import { render } from "./MiddleFront.vue?vue&type=template&id=09d352d8"
import script from "./MiddleFront.vue?vue&type=script&lang=js"
export * from "./MiddleFront.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__